import tinycolor from '../../../libs/tinycolor';
import Please from 'pleasejs';

const minSaturation = 0.5;
const uniqueColorSaturation = 30;

export function getRandomColor() {

	// return a pleasing but random color with enough saturation
	return tinycolor(Please.make_color({
		saturation: Math.min(minSaturation + Math.random(), 1),
		value: 1,
	})[0]);
}

export function assignUniqueColor(obj, palette) {
	let color = null;
	if (palette.Vibrant) {
		color = tinycolor(palette.Vibrant.getHex());
	} else {

		// fall back to a random color
		color = getRandomColor();
	}
	color = color.saturate(uniqueColorSaturation);
	obj.color = {
		palette: palette,
		unique: obj.color ? obj.color : color.toHexString(),  // the object might already have a color set already
	};
}
